import {
  clearAuthSession,
  getRefreshToken,
  getToken,
  hasStoredSession,
} from '@/utils/auth'
import { trySilentRefresh } from '@/utils/refresh'

/**
 * 启动 / 回前台时恢复登录态
 * 1. 有 Refresh Token → 静默续期 Access Token
 * 2. 同步 Pinia 与 storage
 */
export async function renewSessionIfNeeded(): Promise<boolean> {
  if (!hasStoredSession()) return false

  const refreshToken = getRefreshToken()
  if (refreshToken) {
    const result = await trySilentRefresh()
    if (result === 'ok') return !!getToken()
    if (result === 'invalid') {
      clearAuthSession()
      return false
    }
    // network：保留本地凭证，有 Access 则先顶着；无 Access 则视为未登录
    if (result === 'network') return !!getToken()
  }

  return !!getToken()
}
